import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TimeZoneService, TimeZoneUpdater } from '../time-zone-service';

@injectable()
export class TimeZoneServiceImpl implements TimeZoneService, TimeZoneUpdater {
    private _offset: number = 0;

    getUTCOffset(): number {
        return this._offset;
    }

    updateTimeZone(offset: number): void {
        this._offset = offset;
    }
}
